export default __webpack_public_path__ + "static/lost_sector-5cdf6e.svg";